import React from 'react'

export default function Footer() {
  return (
    <footer className="bg-body-tertiary text-center text-lg-start">
    <div className="text-center p-3" style={{"backgroundColor": 'rgba(0, 0, 0, 0.05)'}}>
        <h5>© 2024 Copyright: <a className="text-body" href="https://github.com/riyasachdeva04">riyasachdeva04</a> 🌱</h5>
    </div>
    </footer>
  )
}
